import noop from 'lodash/noop';
import styled from 'styled-components';

import {
  BuyBarSearchLayoutItemMobile,
  BuyBarSearchLayoutItemMobileOneSize,
} from 'productTemplate/components/buyBar/BuyBarSearchLayoutItemMobileOneSize';
import { BuyBarItemMobileNoStock } from 'productTemplate/components/buyBar/BuyBarItemMobileNoStock';
import { IGmcOffers } from 'shared/types/Offer';
import { LOCALES } from 'localization/constants/configEnums';

export const BuyBarMobileSearchLayout = ({
  isCrawler = false,
  priceData,
  locale,
}: {
  isCrawler: boolean;
  priceData: IGmcOffers;
  locale?: LOCALES;
}) => {
  const availableSizes = priceData?.offerData?.sort((a, b) => {
    return a.size - b.size;
  });

  if (!availableSizes || availableSizes?.length === 0) {
    return (
      <BuyBarMobileSearchLayout.Wrapper $isCrawler>
        <BuyBarItemMobileNoStock isCrawler />
      </BuyBarMobileSearchLayout.Wrapper>
    );
  }

  if (availableSizes && availableSizes?.length === 1) {
    return (
      <BuyBarMobileSearchLayout.Wrapper $isCrawler={isCrawler}>
        <BuyBarSearchLayoutItemMobileOneSize
          item={availableSizes[0]}
          onClick={noop}
          locale={locale}
        />
      </BuyBarMobileSearchLayout.Wrapper>
    );
  }

  return (
    <BuyBarMobileSearchLayout.Wrapper $isCrawler={isCrawler}>
      {availableSizes?.map((item) => (
        <BuyBarSearchLayoutItemMobile key={item?.size} item={item} onClick={noop} locale={locale} />
      ))}
    </BuyBarMobileSearchLayout.Wrapper>
  );
};

BuyBarMobileSearchLayout.Wrapper = styled.div<{ $isCrawler: boolean }>`
  ${({ $isCrawler }) => $isCrawler && `padding: 15px;`};
  display: flex;
  flex-wrap: wrap;

  > * {
    color: ${({ theme }) => theme.colors.black};
  }

  ${BuyBarSearchLayoutItemMobile.Wrapper} {
    padding: 5px;
  }
`;
